module.exports = __webpack_public_path__ + "202408221624/img/img_help_bg.7cb74b67.png";